import {
    useSyncExternalStore
} from "react";
import {
    Platform
} from "react-native";
import type {
    PointerListenerType,
    PointerType
} from "../../types/theme";

const COARSE_POINTER_QUERY = "(any-pointer: coarse)";

const pointerTypeListeners = new Set<PointerListenerType>();

let coarsePointerQuery: MediaQueryList | undefined;

const getCoarsePointerQuery = () => {
    if(Platform.OS !== "web" || typeof globalThis.matchMedia !== "function") {
        return undefined;
    }

    if(!coarsePointerQuery) {
        coarsePointerQuery = globalThis.matchMedia(COARSE_POINTER_QUERY);
    }

    return coarsePointerQuery;
};

export const getPointerType = (): PointerType => {
    if(Platform.OS !== "web") {
        return "coarse";
    }

    return getCoarsePointerQuery()?.matches ? "coarse" : "fine";
};

const onCoarsePointerChange = () => {
    const pointerType = getPointerType();

    pointerTypeListeners.forEach((listener) => {
        listener(pointerType);
    });
};

export const subscribePointerType = (listener: PointerListenerType) => {
    const query = getCoarsePointerQuery();

    if(!query || typeof query.addEventListener !== "function") {
        return () => {};
    }

    if(!pointerTypeListeners.size) {
        query.addEventListener("change", onCoarsePointerChange);
    }

    pointerTypeListeners.add(listener);

    return () => {
        pointerTypeListeners.delete(listener);

        if(!pointerTypeListeners.size) {
            query.removeEventListener("change", onCoarsePointerChange);
        }
    };
};

const getServerPointerType = (): PointerType => "fine";

const usePointerType = () => {
    return useSyncExternalStore(subscribePointerType, getPointerType, getServerPointerType);
};
export default usePointerType;
